import { inject, Injectable } from '@angular/core';
import { DragAndDropEvent } from '../../../../../common/drag-drop/types/event';
import { SchedulerMachineDragDropService } from '../../../../../common/scheduler/services/machine-drag-drop.service';
import { FilterSchedulerItem } from '../../../models/';
import { SchedulerItemOnMachineCRUD } from '../../../../../api/elite/dto/scheduler-item-on-machine.dto';
import { SchedulerItemOnMachine } from '../../../../../common/scheduler/models/item-on-machine';
import { SchedulerWorkOrderOnMachineApiService } from '../../../../../common/scheduler/api/work-order-on-machine.service';
import { SchedulerSubWoOnMachineApiService } from '../../../../../common/scheduler/api/sub-wo-on-machine.service';

@Injectable()
export class FilterSchedulerDragDropMachineService extends SchedulerMachineDragDropService<FilterSchedulerItem> {
  private readonly itemOnMachineService = {
    work_order: inject(SchedulerWorkOrderOnMachineApiService),
    sub_work_order: inject(SchedulerSubWoOnMachineApiService),
  };

  protected async insertingItemWhenIsFromMachine(
    event: DragAndDropEvent<FilterSchedulerItem>
  ): Promise<SchedulerItemOnMachine> {
    const itemToMove = event.item.data;
    const machineId = this.generateMachineId(event.container.id);
    const previousMachineId = this.generateMachineId(
      event.previousContainer.id
    );

    const rank = this.createNewRank(event, machineId);

    const body: SchedulerItemOnMachineCRUD['update'] = {
      newMachineId: machineId,
      // In order to get the id of the previous machine we need to check the id of the previous container
      previousMachineId,
      isCurrent: event.container.id.includes('action'),
      itemId: itemToMove.id,
      newRankMachine: this.allowedToBeOrdered && !rank ? itemToMove.rank : rank,
    };
    // @ts-ignore
    return await this.itemOnMachineService[itemToMove.TYPE]
      .updateItem(body)
      .toPromise()
      .then((newItem) => {
        return newItem as SchedulerItemOnMachine;
      });
  }

  protected async insertingItemWhenNotFromMachine(
    event: DragAndDropEvent<FilterSchedulerItem>
  ): Promise<SchedulerItemOnMachine> {
    const itemToMove = event.item.data;
    const machineId = this.generateMachineId(event.container.id);
    const rank = this.createNewRank(event, machineId);
    const body: SchedulerItemOnMachineCRUD['add'] = {
      itemId: itemToMove.id,
      machineId,
      isCurrent: event.container.id.includes('action'),
      isRunning: false,
      rank: rank || itemToMove.rank,
    };
    // @ts-ignore
    return await this.itemOnMachineService[itemToMove.TYPE]
      .addItem(body)
      .toPromise();
  }
}
